import React, { Fragment, useEffect, useMemo, useState } from "react";
import {
  GoogleMap,
  InfoWindowF,
  MarkerF,
  PolylineF,
  useJsApiLoader,
} from "@react-google-maps/api";
import { MDBCard, MDBCardBody, MDBContainer } from "mdb-react-ui-kit";

import "./trace.scss";

// Helper to get today's date string
const today = new Date().toISOString().slice(0, 10);
const thisMonth = today.slice(0, 7); // "YYYY-MM"

const crews = [
  {
    id: 1,
    name: "Alex Gomez",
    role: "Crew Member",
    entries: [
      {
        date: today,
        points: [
          { lat: 40.744, lng: -73.918, time: "06:53 AM", event: "Clocked In", address: "Saran Dr, Farmingdale, NY" },
          { lat: 40.748, lng: -73.925, time: "09:10 AM", event: "Job Location", address: "Roosevelt Field Mall, NY" },
          { lat: 40.756, lng: -73.94, time: "12:30 PM", event: "Lunch Break", address: "Hempstead, NY" },
          { lat: 40.752, lng: -73.93, time: "03:21 PM", event: "Clocked Out", address: "5 Conduit Ave, NY" },
        ],
      },
      {
        date: (() => { const d = new Date(); d.setDate(d.getDate() - 1); return d.toISOString().slice(0, 10); })(),
        points: [
          { lat: 40.741, lng: -73.89, time: "07:00 AM", event: "Clocked In", address: "Jamaica, NY" },
          { lat: 40.76, lng: -73.91, time: "10:00 AM", event: "Job Location", address: "Elmhurst, NY" },
          { lat: 40.758, lng: -73.87, time: "04:00 PM", event: "Clocked Out", address: "Flushing, NY" },
        ],
      },
      {
        date: `${thisMonth}-05`,
        points: [
          { lat: 40.73, lng: -73.85, time: "07:15 AM", event: "Clocked In", address: "Woodside, NY" },
          { lat: 40.75, lng: -73.8, time: "10:30 AM", event: "Job Location", address: "Fresh Meadows, NY" },
          { lat: 40.76, lng: -73.77, time: "02:45 PM", event: "Clocked Out", address: "Little Neck, NY" },
        ],
      },
      {
        date: `${thisMonth}-10`,
        points: [
          { lat: 40.74, lng: -73.99, time: "08:00 AM", event: "Clocked In", address: "LIC, NY" },
          { lat: 40.755, lng: -73.97, time: "11:00 AM", event: "Job Location", address: "Astoria, NY" },
          { lat: 40.762, lng: -73.95, time: "03:30 PM", event: "Clocked Out", address: "Jackson Heights, NY" },
        ],
      },
    ],
  },
  {
    id: 2,
    name: "Anthony Fuller",
    role: "Crew Member",
    entries: [
      {
        date: today,
        points: [
          { lat: 40.733, lng: -73.99, time: "06:40 AM", event: "Clocked In", address: "Queens, NY" },
          { lat: 40.742, lng: -73.88, time: "09:05 AM", event: "Job Location", address: "Forest Hills, NY" },
          { lat: 40.748, lng: -73.76, time: "01:00 PM", event: "Fuel Stop", address: "Valley Stream, NY" },
          { lat: 40.741, lng: -73.66, time: "03:10 PM", event: "Clocked Out", address: "Hicksville, NY" },
        ],
      },
      {
        date: (() => { const d = new Date(); d.setDate(d.getDate() - 1); return d.toISOString().slice(0, 10); })(),
        points: [
          { lat: 40.72, lng: -73.95, time: "06:50 AM", event: "Clocked In", address: "Ridgewood, NY" },
          { lat: 40.73, lng: -73.8, time: "09:45 AM", event: "Job Location", address: "Hollis, NY" },
          { lat: 40.74, lng: -73.7, time: "03:50 PM", event: "Clocked Out", address: "Elmont, NY" },
        ],
      },
      {
        date: `${thisMonth}-08`,
        points: [
          { lat: 40.72, lng: -74.0, time: "07:30 AM", event: "Clocked In", address: "Greenpoint, NY" },
          { lat: 40.735, lng: -73.93, time: "10:15 AM", event: "Job Location", address: "Maspeth, NY" },
          { lat: 40.745, lng: -73.85, time: "02:00 PM", event: "Clocked Out", address: "Ozone Park, NY" },
        ],
      },
    ],
  },
  {
    id: 3,
    name: "Nelson Morales",
    role: "Crew Member",
    entries: [
      {
        date: today,
        points: [
          { lat: 40.77, lng: -73.98, time: "07:34 AM", event: "Clocked In", address: "Manhattan, NY" },
          { lat: 40.74, lng: -73.78, time: "10:12 AM", event: "Job Location", address: "Nassau, NY" },
          { lat: 40.76, lng: -73.55, time: "01:30 PM", event: "Site Visit", address: "Ronkonkoma, NY" },
          { lat: 40.78, lng: -73.24, time: "02:55 PM", event: "Clocked Out", address: "Patchogue, NY" },
        ],
      },
      {
        date: (() => { const d = new Date(); d.setDate(d.getDate() - 2); return d.toISOString().slice(0, 10); })(),
        points: [
          { lat: 40.77, lng: -73.96, time: "07:50 AM", event: "Clocked In", address: "Upper East Side, NY" },
          { lat: 40.74, lng: -73.72, time: "10:40 AM", event: "Job Location", address: "Great Neck, NY" },
          { lat: 40.755, lng: -73.5, time: "03:10 PM", event: "Clocked Out", address: "Hauppauge, NY" },
        ],
      },
      {
        date: `${thisMonth}-03`,
        points: [
          { lat: 40.76, lng: -73.99, time: "08:10 AM", event: "Clocked In", address: "Midtown, NY" },
          { lat: 40.75, lng: -73.75, time: "11:00 AM", event: "Job Location", address: "Floral Park, NY" },
          { lat: 40.77, lng: -73.45, time: "04:00 PM", event: "Clocked Out", address: "Bay Shore, NY" },
        ],
      },
    ],
  },
  {
    id: 4,
    name: "Maria Santos",
    role: "Supervisor",
    entries: [
      {
        date: today,
        points: [
          { lat: 40.76, lng: -73.84, time: "07:00 AM", event: "Clocked In", address: "Springfield Gardens, NY" },
          { lat: 40.74, lng: -73.72, time: "09:30 AM", event: "Job Location", address: "Great Neck, NY" },
          { lat: 40.72, lng: -73.58, time: "02:00 PM", event: "Inspection", address: "Mineola, NY" },
          { lat: 40.71, lng: -73.43, time: "04:30 PM", event: "Clocked Out", address: "Levittown, NY" },
        ],
      },
      {
        date: `${thisMonth}-12`,
        points: [
          { lat: 40.75, lng: -73.95, time: "07:20 AM", event: "Clocked In", address: "Woodhaven, NY" },
          { lat: 40.76, lng: -73.82, time: "10:00 AM", event: "Job Location", address: "Howard Beach, NY" },
          { lat: 40.73, lng: -73.68, time: "03:45 PM", event: "Clocked Out", address: "Belmont, NY" },
        ],
      },
    ],
  },
  {
    id: 5,
    name: "Derek Washington",
    role: "Crew Member",
    entries: [
      {
        date: today,
        points: [
          { lat: 40.69, lng: -73.95, time: "06:30 AM", event: "Clocked In", address: "Flatbush, Brooklyn, NY" },
          { lat: 40.7, lng: -73.83, time: "09:00 AM", event: "Job Location", address: "East New York, NY" },
          { lat: 40.72, lng: -73.75, time: "12:00 PM", event: "Lunch Break", address: "Rosedale, NY" },
          { lat: 40.71, lng: -73.61, time: "03:00 PM", event: "Clocked Out", address: "Merrick, NY" },
        ],
      },
      {
        date: `${thisMonth}-07`,
        points: [
          { lat: 40.68, lng: -73.93, time: "07:45 AM", event: "Clocked In", address: "Crown Heights, NY" },
          { lat: 40.7, lng: -73.8, time: "10:20 AM", event: "Job Location", address: "Cambria Heights, NY" },
          { lat: 40.72, lng: -73.62, time: "03:30 PM", event: "Clocked Out", address: "Freeport, NY" },
        ],
      },
    ],
  },
];

const DEFAULT_CENTER = { lat: 40.75, lng: -73.83 };
const MONTHS_SHORT = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
const MONTHS_FULL = ["January","February","March","April","May","June","July","August","September","October","November","December"];
const DAY_LABELS = ["Su","Mo","Tu","We","Th","Fr","Sa"];

function toDateStr(d) {
  return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`;
}
function fmtDisplay(d) {
  return d ? `${MONTHS_SHORT[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}` : "";
}

function matchesFilter(dateStr, rangeFrom, rangeTo) {
  if (!rangeFrom || !rangeTo) return true;
  return dateStr >= rangeFrom && dateStr <= rangeTo;
}

// ── DateRangePicker component ────────────────────────────────────────────────
function DateRangePicker({ rangeFrom, rangeTo, onChange }) {
  const [open, setOpen] = useState(false);
  const [viewYear, setViewYear] = useState(new Date().getFullYear());
  const [viewMonth, setViewMonth] = useState(new Date().getMonth());
  const [tempStart, setTempStart] = useState(rangeFrom ? new Date(rangeFrom+"T00:00:00") : null);
  const [tempEnd, setTempEnd] = useState(rangeTo ? new Date(rangeTo+"T00:00:00") : null);
  const [hoverDate, setHoverDate] = useState(null);
  const [activePreset, setActivePreset] = useState("today");
  const wrapRef = React.useRef(null);

  const todayObj = useMemo(() => { const d = new Date(); d.setHours(0,0,0,0); return d; }, []);

  useEffect(() => {
    const handler = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const applyPreset = (id) => {
    setActivePreset(id);
    const t = new Date(todayObj);
    let s, e;
    if (id === "today") { s = new Date(t); e = new Date(t); }
    else if (id === "month") { s = new Date(t.getFullYear(), t.getMonth(), 1); e = new Date(t.getFullYear(), t.getMonth()+1, 0); }
    else if (id === "last7") { e = new Date(t); s = new Date(t); s.setDate(t.getDate()-6); }
    else if (id === "last30") { e = new Date(t); s = new Date(t); s.setDate(t.getDate()-29); }
    setTempStart(s); setTempEnd(e);
    setViewMonth(s.getMonth()); setViewYear(s.getFullYear());
  };

  const selectDay = (dt) => {
    if (!tempStart || (tempStart && tempEnd)) {
      setTempStart(dt); setTempEnd(null); setActivePreset(null);
    } else {
      const end = dt < tempStart ? tempStart : dt;
      const start = dt < tempStart ? dt : tempStart;
      setTempStart(start); setTempEnd(end); setActivePreset(null);
    }
  };

  const applyRange = () => {
    if (tempStart && tempEnd) {
      onChange(toDateStr(tempStart), toDateStr(tempEnd));
      setOpen(false);
    }
  };

  const clearRange = () => {
    setTempStart(null); setTempEnd(null); setActivePreset(null);
    onChange("", "");
  };

  const changeMonth = (dir) => {
    let m = viewMonth + dir, y = viewYear;
    if (m > 11) { m = 0; y++; }
    if (m < 0) { m = 11; y--; }
    setViewMonth(m); setViewYear(y);
  };

  const daysInMonth = new Date(viewYear, viewMonth+1, 0).getDate();
  const firstDay = new Date(viewYear, viewMonth, 1).getDay();

  const dayStyle = (dt) => {
    const effectiveEnd = tempEnd || hoverDate;
    const lo = tempStart && effectiveEnd ? (tempStart <= effectiveEnd ? tempStart : effectiveEnd) : null;
    const hi = tempStart && effectiveEnd ? (tempStart <= effectiveEnd ? effectiveEnd : tempStart) : null;
    const isStart = tempStart && dt.getTime() === tempStart.getTime();
    const isEnd = tempEnd && dt.getTime() === tempEnd.getTime();
    const inRange = lo && hi && dt > lo && dt < hi;
    const isToday = dt.getTime() === todayObj.getTime();

    let bg = "transparent", color = "var(--color-text-primary)", radius = "50%", fontWeight = 400;
    if (isStart || isEnd) { bg = "#185FA5"; color = "#fff"; }
    else if (inRange) { bg = "#E6F1FB"; color = "#185FA5"; radius = "0"; }
    if (isToday && !isStart && !isEnd) { fontWeight = 500; color = color === "var(--color-text-primary)" ? "#185FA5" : color; }
    return { background: bg, color, borderRadius: radius, fontWeight, border: isToday && !isStart && !isEnd ? "0.5px solid #B5D4F4" : "none" };
  };

  const diffDays = tempStart && tempEnd ? Math.round((tempEnd - tempStart)/(1000*60*60*24))+1 : 0;

  const labelText = rangeFrom && rangeTo
    ? `${fmtDisplay(new Date(rangeFrom+"T00:00:00"))} — ${fmtDisplay(new Date(rangeTo+"T00:00:00"))}`
    : "Select date range";

  return (
    <div ref={wrapRef} className="position-relative mb-2">
      {/* Input bar */}
      <div onClick={() => setOpen(v => !v)} className="d-flex align-items-center gap-2 py-2 px-3 bg-white rounded-3 cursor-pointer trace-date-input"
        style={{
          border: `0.5px solid ${open ? "#185FA5" : "#e2e8f0"}`,
          boxShadow: open ? "0 0 0 3px #E6F1FB" : "none",
        }}
      >
        <svg width="14" height="14" viewBox="0 0 16 16" fill="none" className="flex-shrink-0"><rect x="1" y="3" width="14" height="12" rx="2" stroke="#94a3b8" strokeWidth="1.2"/><path d="M5 1v3M11 1v3M1 7h14" stroke="#94a3b8" strokeWidth="1.2" strokeLinecap="round"/></svg>
        <span className="small flex-grow-1" style={{ fontWeight: rangeFrom ? 700 : 400, color: rangeFrom ? "#0f172a" : "#94a3b8" }}>{labelText}</span>
        {rangeFrom && (
          <button onClick={(e) => { e.stopPropagation(); clearRange(); }} type="button" className="btn p-0 border-0 bg-transparent trace-date-clear-btn light-slate small lh-sm py-0 px-1" aria-label="Clear date range">×</button>
        )}
      </div>

      {/* Popup */}
      {open && (
        <div className="position-absolute start-0 bg-white border rounded-4 p-3 shadow trace-date-popup">
          {/* Preset chips */}
          <div className="d-flex gap-1 flex-wrap mb-3">
            {[["today","Today"],["month","This month"],["last7","Last 7 days"],["last30","Last 30 days"]].map(([id, label]) => (
              <button key={id} onClick={() => applyPreset(id)} type="button" className="btn btn-sm rounded-pill px-3 py-1 fw-bold trace-preset-btn small-11"
                style={{
                  borderColor: activePreset === id ? "#185FA5" : "#e2e8f0",
                  background: activePreset === id ? "#E6F1FB" : "#f8fafc",
                  color: activePreset === id ? "#185FA5" : "#475569",
                }}
              >{label}</button>
            ))}
          </div>

          {/* Calendar nav */}
          <div className="d-flex align-items-center justify-content-between mb-2">
            <button onClick={() => changeMonth(-1)} type="button" className="btn btn-sm p-0 border-0 bg-transparent text-secondary trace-cal-nav-btn" aria-label="Previous month">‹</button>
            <span className="fw-bold text-dark small-13 trace-cal-title">{MONTHS_FULL[viewMonth]} {viewYear}</span>
            <button onClick={() => changeMonth(1)} type="button" className="btn btn-sm p-0 border-0 bg-transparent text-secondary trace-cal-nav-btn" aria-label="Next month">›</button>
          </div>

          {/* Calendar grid */}
          <div className="trace-cal-grid">
            {DAY_LABELS.map(d => (
              <div key={d} className="text-center fw-bold py-1 trace-cal-dow  snall-11 light-slate">{d}</div>
            ))}
            {Array.from({ length: firstDay }).map((_, i) => <div key={`e${i}`} />)}
            {Array.from({ length: daysInMonth }).map((_, i) => {
              const dt = new Date(viewYear, viewMonth, i+1);
              const ds = dayStyle(dt);
              return (
                <button key={i} onClick={() => selectDay(dt)} onMouseEnter={() => setHoverDate(dt)} onMouseLeave={() => setHoverDate(null)} type="button" className="w-100 d-flex align-items-center justify-content-center trace-cal-day cursor-pointer small-12" style={{ ...ds, border: ds.border || "none", }}>{i+1}</button>
              );
            })}
          </div>

          {/* Footer */}
          <div className="mt-3 pt-3 d-flex align-items-center justify-content-between border-top">
            <span className="small trace-date-footer-label small-11" style={{ color: tempStart && tempEnd ? "#0f172a" : "#94a3b8", fontWeight: tempStart && tempEnd ? 700 : 400 }}>
              {tempStart && tempEnd ? `${diffDays} day${diffDays !== 1 ? "s" : ""} selected` : tempStart ? "Pick end date" : "Pick start date"}
            </span>
            <button onClick={applyRange} disabled={!tempStart || !tempEnd} type="button" className="btn btn-sm rounded-pill px-3 fw-bold border-0 small-12 trace-date-apply-btn"
              style={{
                cursor: tempStart && tempEnd ? "pointer" : "default",
                background: tempStart && tempEnd ? "#185FA5" : "#e2e8f0",
                color: tempStart && tempEnd ? "#fff" : "#94a3b8",
              }}>
              Apply
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default function TracePage() {
  const [query, setQuery] = useState("");
  const [showRoutes, setShowRoutes] = useState(true);

  // Date filter state — single range from/to
  const [rangeFrom, setRangeFrom] = useState(today);
  const [rangeTo, setRangeTo] = useState(today);

  const handleRangeChange = (from, to) => { setRangeFrom(from); setRangeTo(to); };

  const [selectedCrewId, setSelectedCrewId] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null); // which entry date is shown
  const [hoverPoint, setHoverPoint] = useState(null);
  const [hoverIndex, setHoverIndex] = useState(null);
  const [movingArrow, setMovingArrow] = useState(null);
  const [mapInstance, setMapInstance] = useState(null);

  // Derive crews visible in list: those who have at least one entry in the filter range
  const filteredCrews = useMemo(() => {
    const q = query.trim().toLowerCase();
    return crews.filter((c) => {
      if (q && !c.name.toLowerCase().includes(q)) return false;
      return c.entries.some((e) => matchesFilter(e.date, rangeFrom, rangeTo));
    });
  }, [query, rangeFrom, rangeTo]);

  const selectedCrew = useMemo(
    () => crews.find((c) => c.id === selectedCrewId) ?? null,
    [selectedCrewId]
  );

  // For selected crew, filter entries by date range
  const selectedEntries = useMemo(() => {
    if (!selectedCrew) return [];
    return selectedCrew.entries.filter((e) => matchesFilter(e.date, rangeFrom, rangeTo));
  }, [selectedCrew, rangeFrom, rangeTo]);

  // Active entry (specific date selected within crew detail)
  const activeEntry = useMemo(() => {
    if (!selectedEntries.length) return null;
    if (selectedDate) {
      const found = selectedEntries.find((e) => e.date === selectedDate);
      if (found) return found;
    }
    return selectedEntries[0];
  }, [selectedEntries, selectedDate]);

  const routePath = useMemo(() => {
    if (!activeEntry) return [];
    return activeEntry.points.map((p) => ({ lat: p.lat, lng: p.lng }));
  }, [activeEntry]);

  const mapCenter = useMemo(() => {
    if (routePath.length) return routePath[0];
    return DEFAULT_CENTER;
  }, [routePath]);

  const apiKey = "AIzaSyD4kX3D8rScwUZr556zsE3eBBornXMqrVc";

  const { isLoaded, loadError } = useJsApiLoader({
    id: "trace-google-map",
    googleMapsApiKey: apiKey,
  });

  // Animate arrow along hovered segment
  useEffect(() => {
    if (!showRoutes || !activeEntry || hoverIndex == null) {
      setMovingArrow(null);
      return;
    }
    const points = activeEntry.points;
    if (!points[hoverIndex] || !points[hoverIndex + 1]) {
      setMovingArrow(null);
      return;
    }
    let frameId;
    const start = points[hoverIndex];
    const end = points[hoverIndex + 1];
    const steps = 320;
    let step = 0;
    const latStep = (end.lat - start.lat) / steps;
    const lngStep = (end.lng - start.lng) / steps;
    const toRad = (v) => (v * Math.PI) / 180;
    const toDeg = (v) => (v * 180) / Math.PI;
    const y = Math.sin(toRad(end.lng - start.lng)) * Math.cos(toRad(end.lat));
    const x =
      Math.cos(toRad(start.lat)) * Math.sin(toRad(end.lat)) -
      Math.sin(toRad(start.lat)) *
        Math.cos(toRad(end.lat)) *
        Math.cos(toRad(end.lng - start.lng));
    const bearing = (toDeg(Math.atan2(y, x)) + 360) % 360;
    const move = () => {
      step += 1;
      setMovingArrow({
        lat: start.lat + latStep * step,
        lng: start.lng + lngStep * step,
        rotation: bearing,
      });
      if (step < steps) frameId = window.requestAnimationFrame(move);
    };
    move();
    return () => { if (frameId) window.cancelAnimationFrame(frameId); };
  }, [showRoutes, activeEntry, hoverIndex]);

  const handleSelectCrew = (id) => {
    setSelectedCrewId(id);
    setSelectedDate(null);
    setHoverPoint(null);
    setHoverIndex(null);
  };

  const handleBack = () => {
    setSelectedCrewId(null);
    setSelectedDate(null);
    setHoverPoint(null);
    setHoverIndex(null);
  };

  // Flat all active-crew points for map markers (all filtered entries)
  const allActivePoints = useMemo(() => {
    if (!selectedCrew) return [];
    return selectedEntries.flatMap((e) =>
      e.points.map((p) => ({ ...p, entryDate: e.date }))
    );
  }, [selectedCrew, selectedEntries]);

  return (
    <Fragment>
      <MDBContainer fluid className="calendar-container py-3 px-2 px-md-0">
        <MDBCard className="calendar-card">
          <MDBCardBody className="p-0">
            <div className="d-flex trace-min-h-70vh">

              {/* ── Sidebar ─────────────────────────────────────── */}
              <div className="bg-white border-end d-flex flex-column overflow-hidden trace-sidebar">
                {selectedCrew ? (
                  /* ── Crew Detail View ── */
                  <>
                    <div className="p-3 border-bottom">
                      <div className="d-flex align-items-start justify-content-between gap-2">
                        <div className="d-flex gap-2 min-w-0">
                          <div className="rounded-pill bg-secondary-subtle d-flex align-items-center justify-content-center fw-bolder flex-shrink-0 w32-h32 small-13 text-darker" >
                            {selectedCrew.name.split(" ").slice(0, 2).map((s) => s[0]).join("")}
                          </div>
                          <div className="min-w-0">
                            <div className="fw-bolder text-dark small">{selectedCrew.name}</div>
                            <div className="d-flex gap-1 flex-wrap mt-1">
                              <span className="px-3 py-1 rounded-pill fw-bolder small bg-light border text-dark small-11">
                                {selectedCrew.role}
                              </span>
                              <span className="px-3 py-1 rounded-pill fw-bold small bg-primary-subtle border border-primary-subtle text-primary small-11">
                                {selectedEntries.length} day{selectedEntries.length !== 1 ? "s" : ""} in range
                              </span>
                            </div>
                          </div>
                        </div>
                        <button
                          type="button"
                          onClick={handleBack}
                          aria-label="Close"
                          className="btn btn-sm bg-white border rounded-3 p-0 fw-bolder trace-close-btn w32-h32 lh-sm"
                        >×</button>
                      </div>

                      {/* Entry date tabs */}
                      {selectedEntries.length > 1 && (
                        <div className="d-flex gap-1 overflow-auto mt-2 pb-1">
                          {selectedEntries.map((e) => (
                            <button
                              key={e.date}
                              type="button"
                              onClick={() => { setSelectedDate(e.date); setHoverPoint(null); setHoverIndex(null); }}
                              className="btn btn-sm flex-shrink-0 rounded-pill px-3 py-1 fw-bolder trace-entry-tab small-12 cursor-pointer"
                              style={{
                                borderColor: activeEntry?.date === e.date ? "#2563eb" : "#e2e8f0",
                                background: activeEntry?.date === e.date ? "#2563eb" : "#f8fafc",
                                color: activeEntry?.date === e.date ? "#ffffff" : "#0f172a",
                              }}
                            >
                              {e.date}
                            </button>
                          ))}
                        </div>
                      )}
                    </div>

                    <div className="overflow-auto p-3">
                      {!activeEntry ? (
                        <div className="text-center text-muted p-4 small-13">
                          No entries in this date range
                        </div>
                      ) : (
                        <>
                          <div className="text-uppercase fw-bold text-secondary mb-2 small trace-letterspace-006em">
                            {activeEntry.date}
                          </div>
                          {activeEntry.points.map((p, i) => (
                            <div
                              key={i}
                              className="p-3 rounded-3 mb-2 cursor-pointer trace-entry-card"
                              style={{
                                background: hoverIndex === i ? "#f0f9ff" : "#ffffff",
                                border: `1px solid ${hoverIndex === i ? "#bae6fd" : "#e2e8f0"}`,
                              }}
                              onMouseEnter={() => {
                                setHoverPoint(p);
                                setHoverIndex(i);
                                if (mapInstance) mapInstance.panTo({ lat: p.lat, lng: p.lng });
                              }}
                              onMouseLeave={() => { setHoverPoint(null); setHoverIndex(null); }}
                            >
                              <div className="d-flex align-items-center justify-content-between gap-2">
                                <div className="fw-bolder text-dark small-13">{p.time}</div>
                                <span className="trace-event-pill fw-900 small-12 px-10 py-5px rounded-pill" style={{
                                  background: p.event === "Clocked In" ? "#dcfce7" : p.event === "Clocked Out" ? "#fee2e2" : "#f1f5f9",
                                  border: `1px solid ${p.event === "Clocked In" ? "#86efac" : p.event === "Clocked Out" ? "#fca5a5" : "#e2e8f0"}`,
                                  color: p.event === "Clocked In" ? "#15803d" : p.event === "Clocked Out" ? "#dc2626" : "#0f172a",
                                }}>
                                  {p.event}
                                </span>
                              </div>
                              <div className="small text-secondary mt-2 trace-text-12">📍 {p.address}</div>
                            </div>
                          ))}
                        </>
                      )}
                    </div>
                  </>
                ) : (
                  /* ── Crew List View ── */
                  <>
                    <div className="p-3 border-bottom">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <div className="fw-bolder text-dark small-13">
                          Crew Tracker
                        </div>
                        <div className="border bg-light px-3 py-1 rounded-pill fw-bold text-secondary small-12">
                          {filteredCrews.length} crew{filteredCrews.length !== 1 ? "s" : ""}
                        </div>
                      </div>

                      {/* ── Date range picker ── */}
                      <DateRangePicker rangeFrom={rangeFrom} rangeTo={rangeTo} onChange={handleRangeChange} />

                      {/* Search */}
                      <div className="border rounded-3 px-3 py-2 mb-2">
                        <input
                          value={query}
                          onChange={(e) => setQuery(e.target.value)}
                          placeholder="Search crew member…"
                          className="w-100 border-0 bg-transparent trace-search-input outline-none small-12"
                        />
                      </div>

                      {/* Show routes toggle */}
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="fw-bold text-dark small-13">Show routes</div>
                        <button
                          type="button"
                          onClick={() => setShowRoutes((v) => !v)}
                          aria-pressed={showRoutes}
                          className="trace-route-toggle rounded-pill position-relative cursor-pointer"
                          style={{
                            borderColor: showRoutes ? "#2563eb" : "#cbd5e1",
                            background: showRoutes ? "#2563eb" : "#e2e8f0",
                          }}
                        >
                          <span
                            className="position-absolute rounded-pill bg-white trace-route-toggle-knob "
                            style={{
                              left: showRoutes ? 22 : 2,
                            }}
                          />
                        </button>
                      </div>
                    </div>

                    <div className="overflow-auto p-2">
                      {filteredCrews.length === 0 ? (
                        <div className="text-center text-muted p-4 small-13">
                          No crew found in this date range
                        </div>
                      ) : (
                        filteredCrews.map((c) => {
                          const entriesInRange = c.entries.filter((e) =>
                            matchesFilter(e.date, rangeFrom, rangeTo)
                          );
                          const lastPoint = entriesInRange[entriesInRange.length - 1]?.points.slice(-1)[0];
                          return (
                            <div
                              key={c.id}
                              onClick={() => handleSelectCrew(c.id)}
                              role="button"
                              tabIndex={0}
                              onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") handleSelectCrew(c.id); }}
                              className="cursor-pointer p-2 rounded-4 trace-crew-row"
                              onMouseEnter={(e) => e.currentTarget.style.borderColor = "#e2e8f0"}
                              onMouseLeave={(e) => e.currentTarget.style.borderColor = "transparent"}
                            >
                              <div className="rounded-pill bg-secondary-subtle d-flex align-items-center justify-content-center fw-bolder w32-h32 small-12 text-darker">
                                {c.name.split(" ").slice(0, 2).map((s) => s[0]).join("")}
                              </div>
                              <div className="min-w-0">
                                <div className="fw-bolder text-dark small-13">{c.name}</div>
                                <div className="small text-secondary small-12">{c.role}</div>
                                <div className="small text-muted mt-1 small-11">
                                  {entriesInRange.length} day{entriesInRange.length !== 1 ? "s" : ""} · {lastPoint?.address ?? "—"}
                                </div>
                              </div>
                              <button
                                type="button"
                                onClick={(e) => { e.stopPropagation(); handleSelectCrew(c.id); }}
                                className="btn btn-sm btn-outline-primary rounded-pill fw-bolder align-self-center px-3 small-12"
                              >
                                View
                              </button>
                            </div>
                          );
                        })
                      )}
                    </div>
                  </>
                )}
              </div>

              {/* ── Map ─────────────────────────────────────────── */}
              <div className="flex-grow-1 position-relative">
                {loadError && (
                  <div className="position-absolute top-0 start-0 mt-3 ms-3 z-3 bg-white border rounded-4 p-2 shadow-sm">
                    <div className="fw-bolder text-dark small-13">Map failed to load</div>
                    <div className="mt-2 small-12 text-secondary">{String(loadError)}</div>
                  </div>
                )}

                {isLoaded && (
                  <GoogleMap
                    center={mapCenter}
                    zoom={selectedCrew ? 11 : 10}
                    mapContainerClassName="w-100 h-100"
                    onLoad={(map) => setMapInstance(map)}
                    options={{
                      fullscreenControl: false,
                      streetViewControl: false,
                      mapTypeControl: false,
                      clickableIcons: false,
                    }}
                  >
                    {/* All crew last-position markers when no crew is selected */}
                    {!selectedCrew &&
                      filteredCrews.map((c) => {
                        const entriesInRange = c.entries.filter((e) =>
                          matchesFilter(e.date, rangeFrom, rangeTo)
                        );
                        const last = entriesInRange[entriesInRange.length - 1]?.points.slice(-1)[0];
                        if (!last) return null;
                        return (
                          <MarkerF
                            key={c.id}
                            position={{ lat: last.lat, lng: last.lng }}
                            onClick={() => handleSelectCrew(c.id)}
                            label={{ text: c.name.split(" ").slice(0, 2).map((s) => s[0]).join(""), fontWeight: "700" }}
                          />
                        );
                      })}

                    {/* Route for selected crew + active entry */}
                    {showRoutes && routePath.length > 1 && (
                      <>
                        <PolylineF
                          path={routePath}
                          options={{ strokeColor: "#1a73e8", strokeOpacity: 0.9, strokeWeight: 4 }}
                        />

                        {activeEntry?.points.map((p, idx) => (
                          <MarkerF
                            key={`pt-${idx}`}
                            position={{ lat: p.lat, lng: p.lng }}
                            icon={{
                              path: window.google.maps.SymbolPath.CIRCLE,
                              scale: 6,
                              fillColor: "#ffffff",
                              fillOpacity: 1,
                              strokeColor: "#1a73e8",
                              strokeWeight: 2,
                            }}
                            onMouseOver={() => { setHoverPoint(p); setHoverIndex(idx); }}
                          />
                        ))}

                        {hoverPoint && (
                          <>
                            {movingArrow && (
                              <MarkerF
                                position={{ lat: movingArrow.lat, lng: movingArrow.lng }}
                                icon={{
                                  path: window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                                  scale: 3, strokeColor: "#2563eb", fillColor: "#2563eb", fillOpacity: 1,
                                  anchor: new window.google.maps.Point(0, 2),
                                  rotation: movingArrow.rotation ?? 0,
                                }}
                                options={{ clickable: false }}
                                zIndex={999}
                              />
                            )}
                            <MarkerF
                              position={{ lat: hoverPoint.lat, lng: hoverPoint.lng }}
                              icon={{
                                path: window.google.maps.SymbolPath.CIRCLE,
                                scale: 7, fillColor: "#ffffff", fillOpacity: 1,
                                strokeColor: "#1a73e8", strokeWeight: 3,
                              }}
                              zIndex={999}
                            />
                            <InfoWindowF
                              position={{ lat: hoverPoint.lat, lng: hoverPoint.lng }}
                              onCloseClick={() => { setHoverPoint(null); setHoverIndex(null); setMovingArrow(null); }}
                            >
                              <div className="small-12 lh-base">
                                <div className="fw-bolder">{hoverPoint.event}</div>
                                <div>{hoverPoint.time}</div>
                                <div className="text-secondary">{hoverPoint.address}</div>
                              </div>
                            </InfoWindowF>
                          </>
                        )}
                      </>
                    )}
                  </GoogleMap>
                )}
              </div>
            </div>
          </MDBCardBody>
        </MDBCard>
      </MDBContainer>
    </Fragment>
  );
}